module.exports = __webpack_public_path__ + "img/folder-minus.35c45380.svg";